import React, { useRef, useState } from 'react';
import cls from './ArchiveAccounts.module.css';
import classNames from 'classnames';
import { ArchiveAccountsList } from './ArchiveAccountsList/ArchiveAccountsList';

export const ArchiveAccounts = ({
    accounts,
    activeMoreMenu,
    setActiveMoreMenu,
    setIsShowPopup,
}) => {
    const [isShowList, setIsShowList] = useState(true);

    const onHideList = () => {
        setIsShowList(!isShowList);
    };

    return (
        <div className={classNames(cls.wrapper)}>
            <div className={classNames(cls.header)}>
                {i18next.t('ArchiveAccounts.return.header.text')}
                <button
                    onClick={onHideList}
                    className={classNames(cls.headerButton, { [cls.show]: !isShowList })}
                >
                    {isShowList
                        ? i18next.t('ArchiveAccounts.return.header.button.hide')
                        : i18next.t('ArchiveAccounts.return.header.button.show')}
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.083 10.6826C12.9268 10.8389 12.6736 10.8389 12.5174 10.6826L8.00019 6.16548L3.48307 10.6826C3.32683 10.8389 3.07355 10.8389 2.91731 10.6826C2.76115 10.5264 2.76115 10.2732 2.91731 10.117L7.71731 5.31692C7.87355 5.16076 8.12683 5.16076 8.28307 5.31692L13.083 10.117C13.2392 10.2732 13.2392 10.5264 13.083 10.6826Z"
                            fill="#757575"
                        />
                    </svg>
                </button>
            </div>
            {isShowList && (
                <ArchiveAccountsList
                    accounts={accounts}
                    setIsShowPopup={setIsShowPopup}
                    activeMoreMenu={activeMoreMenu}
                    setActiveMoreMenu={setActiveMoreMenu}
                />
            )}
        </div>
    );
};
